<template>
  <div>
    <h1 class="text-h5">REGISTRO DE ASISTENCIA DEL SOCIO</h1>
    <!-- <v-text-field
      type="text"
      label="Número de cedula"
      v-model="cedula"
      autofocus
      @keyup.enter="registrar"
    /> -->

    <div v-if="!evento">
      <h2>Seleccione un evento</h2>
      <v-data-table :items="eventos" :headers="headers">
        <template v-slot:[`item.actions`]="props">
          <td>
            <v-btn v-if="props.item.estado === 'EN_CURSO'" small color="success"
              @click="seleccionarEvento(props.item, 'registrar')">REGISTRAR</v-btn>
          </td>
          <td>
            <v-btn class="ml-2" v-if="props.item.estado === 'EN_CURSO'" small color="success"
              @click="seleccionarEvento(props.item, 'consultar')">CONSULTAR</v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-else>
      <h2 class="text-h5">{{ evento.nombre }}</h2>
      <h1 class="mt-3 text-h6 text-center">DIGITE NUMERO DE CEDULA</h1>
      <input @blur="enfocar" ref="cedulaInput" type="text" v-model="cedula" style="
          border: 1px solid black;
          margin: auto;
          height: 90px;
          width: 500px;
          padding: 30px;
          display: block;
          font-size: 50px;
        " @keyup.enter="buscar" />

      <h1 class="red--text text-center">{{ errorMessage }}</h1>
      <h1 v-if="mostrarMensajeOk && socioRegistrado && !errorMessage" class="green--text text-center">
        SOCIO REGISTRADO CON EXITO!
      </h1>


      <h2 class="text-center mt-2" v-if="persona">
        {{ persona.nombres }} {{ persona.seudonimo ? '(' + persona.seudonimo + ')' : '' }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        CEDULA: {{ persona.cedula }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        {{ persona.tipo }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        ORDEN: {{ persona.orden }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        MESA: {{ persona.mesa }}
      </h2>
      <div class="text-center mt-2" v-if="persona && persona.aviso">
        <h1 class="red--text">
          AVISO: {{ persona.aviso }}
        </h1>
      </div>
      <!-- <Ficha :persona="this.persona" v-if="persona" /> -->
      <v-card v-if="persona">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="registrar"
            v-if="!socioRegistrado && !errorMessage && modo == 'registrar'">REGISTRAR</v-btn>
          <v-btn color="info" @click="anularRegistro" v-if="socioRegistrado && !errorMessage">ANULAR REGISTRO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import Ficha from "@/views/eventosSociales/Ficha.vue";

export default {
  data() {
    return {
      loading: false,
      cedula: "",
      mostrarMensajeOk: false,
      mostrarMensajeErr: false,
      errorMessage: "",
      evento: null,
      modo: 'registro',
      eventos: [],
      headers: [
        { text: "Id", value: "id" },
        { text: "Nombre", value: "nombre" },
        { text: "Estado", value: "estado" },
        { text: "", value: "actions" },
      ],
      persona: null,
      socioRegistrado: false,
    };
  },

  methods: {
    async buscar() {
      this.errorMessage = "";
      this.mostrarMensajeOk = false;

      this.persona = null;

      this.loading = true;

      // await axios.get("/persona/buscar?valor=" + this.cedula + "&propiedad=cedula").then(
      //   response => {
      //     console.log('buscar *****' , response)
      //     if (response.data.length == 0) {

      //       this.errorMessage = "No existe el socio con cedula: " + this.cedula;
      //       return;
      //     }
      //     this.persona = response.data[0];
      //   }
      // ).catch (err => {
      //   this.loading = false;
      //     console.log(err);
      //     if (err && err.response && err.response.data) {
      //       this.errorMessage = err.response.data + " cedula: " + this.cedula;
      //     } else {
      //       this.errorMessage = "Error";
      //     }
      //     return;
      // });

      await axios
        .get(
          "/eventoSocial/checkHabilitado?cedula=" +
          this.cedula +
          "&eventoSocialId=" +
          this.evento.id
        )
        .then((response) => {
          console.log(
            "************************************************CheckHabilitado",
            response
          );
          if (response.data) {
            this.persona = response.data;
          } else {
            this.errorMessage = "Sin datos "
          }

        })
        .catch((err) => {
          console.log(err);
          alert("ocurrio un error");
        });

      if (this.persona && this.modo === 'registrar') await this.registrar();
    },

    async registrar() {
      this.errorMessage = "";


      // this.checkHabilitado();

      this.socioRegistrado = false;

      this.loading = true;

      await axios
        .post("/eventoSocial/registrarAsistenciaSocio", {
          cedula: this.persona.cedula,
          eventoId: this.evento.id,
        })
        .then((response) => {
          console.log(response);
          this.mostrarMensajeOk = true;
          this.socioRegistrado = true;

          if (response.data == 'YA REGISTRADO') {
            alert('cedula registrada previamente')
          }
          // this.$emit("nuevaCedula", {
          //   id: this.id,
          //   nuevaCedula: this.nuevaCedula,
          // });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data + " cedula: " + this.cedula;
          } else {
            this.errorMessage = "Error";
          }
        });

      this.cedula = "";
      this.loading = false;
    },
    async checkHabilitado() {
      if (!this.cedula) return;

      await axios
        .get(
          "/eventoSocial/checkHabilitado?cedula=" +
          this.cedula +
          "&eventoSocialId=" +
          this.evento.id
        )
        .then((response) => {
          console.log(
            "************************************************",
            response
          );
        })
        .catch((err) => {
          console.log(err);
          alert("ocurrio un error");
        });
    },
    enfocar() {
      console.log("enfocamos");
      if (this.$refs.cedulaInput) this.$refs.cedulaInput.focus();
    },
    async seleccionarEvento(evento, modo) {
      this.modo = modo;
      this.evento = evento;
      this.enfocar();
    },

    async anularRegistro() {
      if (!this.socioRegistrado) return;

      if (!confirm("Desea anular este registro?")) return;

      await axios
        .post("/eventoSocial/anularRegistro", {
          cedula: this.persona.cedula,
          eventoId: this.evento.id,
        })
        .then((response) => {
          console.log(response);
          this.mostrarMensajeOk = true;
          this.socioRegistrado = true;
          // this.$emit("nuevaCedula", {
          //   id: this.id,
          //   nuevaCedula: this.nuevaCedula,
          // });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data + " cedula: " + this.cedula;
          } else {
            this.errorMessage = "Error";
          }
        });

      this.socioRegistrado = false;
    },
  },
  mounted() {
    // this.enfocar();

    // this.eventoId = this.$route.query.eventoId;

    axios
      .get("/eventoSocial/")
      .then((response) => {
        console.log("eventoSocial", response);
        this.eventos = response.data
          .filter(e => e.estado !== "FINALIZADO")
          .sort((a, b) => b.id - a.id);
        // this.eventos = response.data;
      })
      .catch((err) => {
        console.log(err);
      });

    // this.$refs.cedulaInput.blur(() => {
    //   console.log("BLUR EJECUTADO");
    //   setTimeout(() => {
    //     this.$refs.cedulaInput.focus();
    //   }, 1000);
    // });

    // setInterval(()=> {
    //     console.log('interval ejecutado')
    //     this.$refs.cedulaInput.focus();
    // }, 2000);
  },
  components: {
    // Ficha,
  },
};
</script>